import { PROBLEMS } from "@/data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Problems = () => (
  <section id="problem" data-testid="problem-section" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-36">
    <div className="grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start">
        <Reveal><Eyebrow>Das Problem</Eyebrow></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1] tracking-[-0.03em]">
            Das Becken ist gut. <span className="text-[var(--signal)]">Die Technik</span> ist von gestern.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-md text-base sm:text-lg text-[var(--mist)]">
            Viele Pools sind baulich in Ordnung – nur die Technik dahinter wurde nie mitgedacht. Kommt Ihnen etwas davon bekannt vor?
          </p>
        </Reveal>
      </div>
      <ol className="lg:col-span-7 border-t border-white/10">
        {PROBLEMS.map((p, i) => (
          <Reveal as="li" key={p.n} delay={i * 0.06} className="group border-b border-white/10">
            <div data-testid={`problem-item-${p.n}`} className="grid grid-cols-[3.5rem_1fr] gap-4 py-8 sm:grid-cols-[5rem_1fr] sm:py-10 transition-[padding] duration-500 group-hover:pl-3">
              <span className="font-mono text-sm text-[var(--signal)]">{p.n}</span>
              <div>
                <h3 className="font-display text-2xl sm:text-3xl font-medium tracking-[-0.02em] text-[var(--foam)]">{p.title}</h3>
                <p className="mt-3 max-w-lg text-sm sm:text-base text-[var(--mist)]">{p.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
